/** @flow */

import SearchWorkerLoader from "./SearchWorkerLoader";

export default SearchWorkerLoader;



// WEBPACK FOOTER //
// ./src/worker/index.js